import {
    initialSources,
    initialStatuses,
} from "components/PaymentsLanding/Tabs/PaymentsActivity/PaymentsActivityBar/paymentsActivityStatusFilterHelpers";
import type { PatientActivitySearchParams, PatientActivitySearchParamsPartial } from "routes/history/patients";
import type { PaymentsActivitySearchParams, PaymentsActivitySearchParamsPartial } from "routes/history/payments";

export function getPatientActivityDefaultSearch(
    search: PatientActivitySearchParamsPartial,
): PatientActivitySearchParamsPartial {
    return {
        patientName: typeof search.patientName === "string" ? search.patientName : "",
        status: Array.isArray(search.status) ? search.status : [],
    } satisfies PatientActivitySearchParams;
}

export function getPaymentsActivityDefaultSearch(
    search: PaymentsActivitySearchParamsPartial,
): PaymentsActivitySearchParams {
    return {
        patientName: typeof search.patientName === "string" ? search.patientName : "",
        statuses: Array.isArray(search.statuses) && search.statuses.length > 0 ? search.statuses : [...initialStatuses],
        sources: Array.isArray(search.sources) && search.sources.length > 0 ? search.sources : [...initialSources],
    } satisfies PaymentsActivitySearchParams;
}
